var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Notifications',{attrs:{"max":1,"width":"100%"},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('Notification',{attrs:{"message":props.item.text,"type":props.item.type,"name":"toast"},on:{"close":props.close}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }